import { Card, Spin } from 'antd';
import { memo, useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Background from '../assets/background.jpeg';
import { AuthContext } from '../contexts/AuthContext';

const Auth = () => {
  const {
    authState: { authLoading, isAuthenticated },
  } = useContext(AuthContext);

  let body;
  if (authLoading) {
    body = (
      <div style={{ margin: 'auto' }}>
        <Spin size="large" />
      </div>
    );
  } else if (isAuthenticated) {
    return <Navigate to="/" />;
  } else {
    body = <Outlet />;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        minWidth: '100%',
        minHeight: '100%',
        height: '100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage: `url(${Background})`,
      }}
    >
      <div
        style={{
          opacity: 0.2,
          backgroundColor: '#1A1A1A',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      ></div>
      <div className="auth">
        <Card
          title="Login with YumYum account"
          style={{
            width: 400,
            position: 'fixed',
            top: '30%',
            left: '50%',
            transform: 'translate(-50%, -20%)',
          }}
        >
          {body}
        </Card>
      </div>
    </div>
  );
};

export default memo(Auth);
